import {
  SET_LOCALE_START,
  SET_LOCALE_SUCCESS,
  SET_LOCALE_ERROR,
  langTable,
} from '../constants';

const language = langKey => {
  // langTable jest tablicą pobieraną z /constants/index.js
  // funkcja zwraca objekt z kluczami i wartosciami w odpowiednim jezyku
  function choosenLang(tabKey) {
    let newObject = {};
    langTable.map((v, i) => {
      newObject[Object.keys(v)] = Object.values(v)[0][tabKey] ? Object.values(v)[0][tabKey] : Object.values(v)[0][0];
    });
    return newObject;
  }
  if (langKey === 'en-EN') {
    return choosenLang(1);
  } else if (langKey === 'de-DE') {
    return choosenLang(2);
  } else {
    // zwraca Polski
    return choosenLang(0);
  }
};

const intlInitialState = {
  locale: 'pl-PL',
  newLocale: 'pl-PL',
  langKeys: language('pl-PL'),
};

export default function intl(state = intlInitialState, action) {
  if (state === null) {
    return {
      initialNow: Date.now(),
    };
  }

  switch (action.type) {
    case SET_LOCALE_START: {
      const locale = action.payload.locale ? action.payload.locale : state.locale;
      return {
        ...state,
        locale,
        newLocale: action.payload.locale,
        langKeys: language(locale),
      };
    }

    case SET_LOCALE_SUCCESS: {
      return {
        ...state,
        locale: action.payload.locale,
        newLocale: null,
        langKeys: language(action.payload.locale),
        messages: action.payload.messages,
      };
    }

    case SET_LOCALE_ERROR: {
      return {
        ...state,
        newLocale: null,
        langKeys: language('pl-PL'),
      };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// src/reducers/intl.js